/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 15:33:13
 * @FilePath: /unifyxp-v2-store-portal/src/layout/store/index.tsx
 */
import { createSlice } from '@reduxjs/toolkit';
// import { languageDict } from "../../index";
//  const systemLang = navigator.language.split("-")[0];
//  const lang = languageDict[systemLang || ""] || "en-AU";

const defaultState = {
  position: 'Vertical',
  isSiderCollapsed: false,
  contentContainerWidth: 0,
};

const mainLayoutSlice = createSlice({
  name: 'mainLayout',
  initialState: defaultState,
  reducers: {
    changeSiderPosition: (state, action) => {
      const { position } = action.payload;
      state.position = position;
    },
    changeSiderOpen: (state, action) => {
      // const { collapse } = action.payload;
      state.isSiderCollapsed = action.payload;
    },
    setContentWidth(state, action) {
      state.contentContainerWidth = action.payload;
    },
  },
});
export const { changeSiderPosition, changeSiderOpen, setContentWidth } =
  mainLayoutSlice.actions;
//
export default mainLayoutSlice.reducer;
